import React, { useState } from "react";

function Accordion(props) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const list = props.list
    ? props.list.map((item) => <li key={item}>{item}</li>)
    : null;

  return (
    <div className="accordion" onClick={toggleAccordion}>
      <div className="accordion-header">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            {props.title}
            {props.sup ? <sup>{props.sup}</sup> : null}{" "}
          </div>
          <span>{isOpen ? "-" : "+"}</span>
        </div>
      </div>
      {isOpen && (
        <div className="accordion-body">
          {props.content ? props.content : null}{" "}
          {props.list ? <ul className="cust-ul list-disc">{list}</ul> : null} {props.children}
        </div>
      )}
    </div>
  );
}

export default Accordion;
